import _ from 'lodash'
import Component from 'vue-class-component'
import { IComponentData, IContainerData } from '../../store/editor/components/state'
import ComponentVue from './Component'
import ComponentVueFactory from './ComponentVueFactory'
import Vue from 'vue'

@Component
export default class ContainerVue<T extends IContainerData> extends ComponentVue<T> {
  get childIds(): string[] {
    const data = this.componentData
    return (data && data.childIds) ? data.childIds : []
  }

  get childId(): string {
    const ids = this.childIds
    return ids.length >= 0 ? ids[0] : ''
  }

  get children(): IComponentData[] {
    const ids = this.childIds
    return _.map(ids, this.getComponentData)
  }

  get child(): IComponentData | undefined {
    const id = this.childId
    return id ? this.getComponentData(this.childId) : undefined
  }

  get firstChild(): IComponentData | undefined {
    return this.child
  }

  get lastChild(): IComponentData | undefined {
    const ids = this.childIds
    return ids.length >= 0 ? this.getComponentData(ids[ids.length - 1]) : undefined
  }

  getComponentVue(id: string): typeof Vue {
    const componentData = this.getComponentData(id)
    return ComponentVueFactory.get(componentData)
  }
}
